import { styled } from "@mui/material/styles";
import { Autocomplete } from "@mui/material";

const RoundAutoComplete = styled(Autocomplete)`
    background: #E3E8EF;
    border-radius: 16px;
    padding: 0px;
    height: fit-content;
    margin-top: 18px;
    
    & .MuiOutlinedInput {
        border: 0px;
    }

    & .MuiOutlinedInput-root {
        border-radius: 16px;
        padding: 1px;
        border: 0px;
        padding-left: 10px;
        color: #1D1761;
        font-weight: 500;
    }

    & .MuiButtonBase-root {
        margin-top: 4px;
    }
`;

export default RoundAutoComplete;